import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '@app/core/services';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  form: FormGroup;

  apiErrors = {};

  isLoading = false;
  isSuccessfullySended: boolean;

  ngUnsubscribe = new Subject();

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      email: ['', ],
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  submit() {
    if (this.isLoading) return;

    this.isLoading = true;

    this.apiErrors = {};

    this.authService.forgotPassword(this.form.get('email').value)
      .pipe(takeUntil(this.ngUnsubscribe))
      .finally(() => this.isLoading = false)
      .subscribe(response => this.isSuccessfullySended = true, error => this.apiErrors = error.error);
  }
}



// WEBPACK FOOTER //
// ./src/app/accounts/forgot-password/forgot-password.component.ts